import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import StudentService from '../../services/studentServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('student/list', async ({ status, query }, thunkAPI) => {
  try {
    const response = await StudentService.getList(status, query);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('student/create', async (data, thunkAPI) => {
  try {
    const response = await StudentService.create(data);

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('student/read', async (id, thunkAPI) => {
  try {
    const response = await StudentService.read(id);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('student/update', async (data, thunkAPI) => {
  try {
    const response = await StudentService.update(data.id, data);

    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateRef = createAsyncThunk('student/updateRef', async (data, thunkAPI) => {
  try {
    const response = await StudentService.updateRef(data.id, data);

    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('student/delete', async (id, thunkAPI) => {
  try {
    const response = await StudentService.del(id);

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});
export const addMapel = createAsyncThunk('student/addMapel', async ({ id, mapelID }, thunkAPI) => {
  try {
    const response = await StudentService.addMapel(id, mapelID);
    thunkAPI.dispatch(readData(id));
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
export const delMapel = createAsyncThunk('student/delMapel', async ({ id, mapelID }, thunkAPI) => {
  try {
    const response = await StudentService.delMapel(id, mapelID);
    thunkAPI.dispatch(readData(id));
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changeStatus = createAsyncThunk('student/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await StudentService.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updatePhoto = createAsyncThunk('student/updatePhoto', async ({ id, photo }, thunkAPI) => {
  try {
    const response = await StudentService.updatePhoto(id, photo);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deletePhoto = createAsyncThunk('student/deletePhoto', async (id, thunkAPI) => {
  try {
    const response = await StudentService.deletePhoto(id);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const verifyStudent = createAsyncThunk('student/verifyStudent', async (id, thunkAPI) => {
  try {
    const response = await StudentService.verifyStudent(id);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getCode = createAsyncThunk('student/code', async ({ page, perPage, sort, orderBy, search }, thunkAPI) => {
  try {
    const response = await StudentService.getCode(page, perPage, sort, orderBy, search);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getCodeHistory = createAsyncThunk('student/getCodeHistory', async (id, thunkAPI) => {
  try {
    const response = await StudentService.getCodeHistory(id);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const storePayment = createAsyncThunk('student/storePayment', async (id, thunkAPI) => {
  try {
    const response = await StudentService.storePayment(id);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const storeRefferal = createAsyncThunk('student/storeRefferal', async (data, thunkAPI) => {
  try {
    const response = await StudentService.storeRefferal(data.id, data);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteRefferal = createAsyncThunk('student/deleteRefferal', async ({ id, referid }, thunkAPI) => {
  try {
    const response = await StudentService.deleteRefferal(id, referid);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changePassword = createAsyncThunk('student/changePassword', async ({ id, data }, thunkAPI) => {
  try {
    const response = await StudentService.changePassword(id, data);

    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const gradeUp = createAsyncThunk('student/gradeUp', async ({ id, data }, thunkAPI) => {
  try {
    const response = await StudentService.gradeUp(id, data);

    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const gradeUpAll = createAsyncThunk('student/gradeUpAll', async (_, thunkAPI) => {
  try {
    const response = await StudentService.gradeUpAll();

    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const processGradeUp = createAsyncThunk('student/processGradeUp', async ({ id, data }, thunkAPI) => {
  try {
    const response = await StudentService.processGradeUp(id, data);

    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const activateAllGradeUp = createAsyncThunk('student/activateAllGradeUp', async (_, thunkAPI) => {
  try {
    const response = await StudentService.activateAllGradeUp();

    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const movePendingToGradeUp = createAsyncThunk('student/movePendingToGradeUp', async (_, thunkAPI) => {
  try {
    const response = await StudentService.movePendingToGradeUp();

    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const exportDataStudent = createAsyncThunk('student/exportDataStudent', async ({ query }, thunkAPI) => {
  try {
    const response = await StudentService.exportDataStudent(query);
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], payment: {}, data: [], history: [], error: [] };

const studentSlice = createSlice({
  name: 'student',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = isObject(action.payload.errors) ? action.payload.errors : [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.errors ? action.payload.errors : [];
      }),
      builder.addCase(updateRef.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateRef.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(updateRef.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.errors ? action.payload.errors : [];
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addMapel.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addMapel.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addMapel.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(delMapel.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(delMapel.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(delMapel.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updatePhoto.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updatePhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(updatePhoto.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deletePhoto.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deletePhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(deletePhoto.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(verifyStudent.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(verifyStudent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(verifyStudent.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getCode.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getCode.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getCode.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getCodeHistory.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getCodeHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.student;
        state.history = action.payload.data;
      }),
      builder.addCase(getCodeHistory.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(storeRefferal.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(storeRefferal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(storeRefferal.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteRefferal.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteRefferal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(deleteRefferal.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(storePayment.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(storePayment.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(storePayment.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changePassword.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changePassword.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changePassword.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(gradeUp.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(gradeUp.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(gradeUp.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(gradeUpAll.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(gradeUpAll.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(gradeUpAll.rejected, (state) => {
        state.isLoading = false;
      });
    builder.addCase(exportDataStudent.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(exportDataStudent.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(exportDataStudent.rejected, (state) => {
      state.isLoading = false;
    });
  }
});

const { reducer } = studentSlice;
export default reducer;
